import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api'; // centralized Axios instance

export const loginThunk = createAsyncThunk(
  'auth/login',
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await api.post('/api/web/auth/send-login-otp', { email, password });

      // Store token in localStorage for persistence
      if (response.data?.token) {
        localStorage.setItem('token', response.data.token);
      }

      return { status: response.status, data: response.data };
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status || 500,
        data: error.response?.data || { message: 'Login failed' },
      });
    }
  }
);